import { useEffect } from 'react'

import { useSearchParams } from 'react-router-dom'

import logger from '@cash-web/shared/util-logger'
import { RedirectToMobile } from '@cash-web/shared-feature-redirect-to-mobile'

export const JourneyNotFound = () => {
  const [searchParams] = useSearchParams()
  const clientRouteUrl = searchParams.get('clientRouteUrl') ?? undefined

  useEffect(() => {
    logger.info(new Error(`Client route not found: ${clientRouteUrl}`))
  }, [clientRouteUrl])

  return <RedirectToMobile clientRouteUrl={clientRouteUrl} />
}
